<script setup lang="ts">
const {toasts, removeToast} = useToasts();
</script>

<template>
  <div class="toast-container position-fixed p-5 bottom-0 start-50 translate-middle-x" style="z-index: 1100">
    <div
        v-for="toast in toasts"
        :key="toast.id"
        class="toast show align-items-center border-0"
        :class="[`text-bg-${toast.type || 'info'}`]"
        role="alert"
    >
      <div class="toast-header">
        <strong class="me-auto">{{ toast.title }}</strong>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close" @click="removeToast(toast.id)"></button>
      </div>
      <div class="toast-body d-flex flex-column justify-center align-items-center">
        <span>{{ toast.message }}</span>
        <div v-if="toast.action" class="px-3 py-1">
          <button class="btn btn-sm btn-light border-0 fw-bold" @click="toast.action.onClick(toast.id)">
            {{ toast.action.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>